import React from "react";
import { observer } from "mobx-react";
import { Event } from "@gp/models";

export const AggregatedScore = observer(function AggregatedScore({
	event,
}: {
	event: Event;
}) {
	if (!event.result?.aggregateScore) {
		return null;
	}

	return (
		<div className="match__aggregate">
			<div>({event.result.aggregateScore.home || 0})</div>
			<div>({event.result.aggregateScore.away || 0})</div>
		</div>
	);
});
